import {
	defaultTqcTestDtlDto,
	TqcTestDtlDto,
	defaultTqcTestHdrDto,
	TqcTestHdrDto,
} from "src/dtos/tqctest/tqcTestDto";

export interface TQC2050_R01HeaderDto extends TqcTestHdrDto {
	modelNo: string;
	customNm: string;
}

export interface TQC2050_R01DetailDto extends TqcTestDtlDto {
	statItem: string;
	statResult: string;
}

export interface TQC2050_R01Dto {
	tqcTestHeaderDto: TQC2050_R01HeaderDto;
	tqcTestDetailDtoList: TQC2050_R01DetailDto[];
}

export const defaultTQC2050_R01HeaderDto: TQC2050_R01HeaderDto = {
	...defaultTqcTestHdrDto,
	modelNo: '',
	customNm: '',
};

export const defaultTQC2050_R01DetailDto: TQC2050_R01DetailDto = {
	...defaultTqcTestDtlDto,
	statItem: '',
	statResult: '',
};

export const defaultTQC2050_R01Dto: TQC2050_R01Dto = {
	tqcTestHeaderDto: defaultTQC2050_R01HeaderDto,
	tqcTestDetailDtoList: [],
};
